module.exports = __webpack_public_path__ + "media/images/folder_expand-853f98c0bc7787ae17871f1ba827e268.svg";